import basicTheme from '../basicTheme.js';

const accordionStyleOverrides = {
    styleOverrides: {
        root: {
            background: basicTheme.palette.N50.main,
            borderRadius: '4px',
            margin: '0 0 8px 0 !important',
            boxShadow: 'none',
            '&:hover': {
                background: basicTheme.palette.N40.main,
            },
            '::before': {
                content: 'none',
            },
        },
    },
};

export { accordionStyleOverrides as default };
//# sourceMappingURL=MuiAccordion.js.map
